import {View} from 'MWC';
import tpl from '../../templates/tablet/main';
import React from 'react';
import PropTypes from 'prop-types';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
        return this;
    }
    template = tpl;

    handleOutsideClick = event => {
        if (
            this.state.isOpen &&
            !event.target.closest('.tablet-header-menu-wrapper') &&
            !event.target.closest('.icon-menu__wrapper')
        ) {
            this.setState({isOpen: false});
        }
    };

    applyModeFromUrl() {
        const {active, isBusiness} = this.props;
        const pathname = this.context.history.location.pathname;

        let mode;

        if (pathname === '/') {
            mode = 'cards';
        } else if (isBusiness) {
            mode = active === 'businessDefault' ? 'businessCalculations' : active;
        } else {
            mode = active === 'individualDefault' ? 'cards' : active;
        }

        if (this.state.mode !== mode) {
            this.setState({mode});
        }
    }

    componentDidMount() {
        this.applyModeFromUrl();
        this.unlisten = this.props.history.listen(() => {
            this.applyModeFromUrl();
        });

        document.addEventListener('click', this.handleOutsideClick);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isBusiness !== this.props.isBusiness) {
            const mode = this.props.isBusiness ? 'businessCalculations' : 'cards';

            if (this.state.mode !== mode) {
                this.setState({mode});
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        if (this.unlisten) this.unlisten();
    }

    toggleMenu() {
        this.setState(prevState => {
            const isOpen = !prevState.isOpen;

            let mode = prevState.mode;

            if (isOpen) {
                const {active, isBusiness} = this.props;

                if (isBusiness) {
                    mode = active === 'businessDefault' ? 'businessCalculations' : active;
                }
            }

            return {isOpen, mode};
        });
    }

    toggleMode(mode) {
        this.setState({mode: mode});
    }

    static contextTypes = {
        history: PropTypes.object
    };

    static displayName = 'Header.Views.Tablet';
}
